<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @btnClick="handleBtnClick"
            searchId="driverExpenseManageQuery"
            pageID="driverExpenseManage"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="DRIVER_EXPENSE_MANAGE_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                v-has="'08000602'"
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    v-has="'08000601'"
                    type="primary"
                    :loading="approvalBtnLoading"
                    :disabled="!this.selected.length"
                    @click="handleApproval"
                    >异常申诉</el-button
                >
            </div>
        </m-pane>

        <!-- 附件查看 -->
        <attachment-dialog
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :attachmentList="attachmentList"
        >
        </attachment-dialog>
        <!-- 确认状态推送BMS记录 -->
        <confirm-status-dialog
            v-if="confirmStatusDialogShow"
            :confirmStatusDialogShow.sync="confirmStatusDialogShow"
            :componentsData="rowData"
            :dictData="dictData"
            @refresh="refresh"
        ></confirm-status-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import config from './config.js';
import dayjs from 'dayjs';
import { mapState, mapGetters } from 'vuex';
import { dictWithUrl } from '@/components/lots/api.js';
import { formatSearchData, validateSearchData, formatTotalDataList, setAllPropertyValuesToNull, removeFalsyValues } from './util';
import { queryPage, queryCount, queryDriverAttachment, abnormalAppeal, queryApolloSiteCodeList } from '../../../api/driverExpenseManage.js';
import reportExport from '@/components/lots/reportExportPlugin';
import AttachmentDialog from './components/attachmentDialog.vue';
import ConfirmStatusDialog from './components/ConfirmStatusDialog.vue';
export default {
    name: 'DriverExpenseManage',
    components: {
        paper,
        mPane,
        reportExport,
        AttachmentDialog,
        ConfirmStatusDialog
    },
    data () {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            isFirstSearch: true,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: [],
            attachmentShow: false,
            attachmentList: [],
            approvalBtnLoading: false,
            confirmStatusDialogShow: false,
            dictData: {},
            siteCodeList: [] // 阿波罗配置的服务平台
        };
    },
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            user: state => state.user,
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        })
    },
    mounted () {
        this.getDicData();
    },
    beforeRouteEnter (to, from, next) {
        if (from.path === '/index') {
            next(vm => {
                vm.$nextTick(() => {
                    if (vm.$route.query && Object.keys(vm.$route.query).length) {
                        vm.initialSearchFromIndex();
                    }
                })
            });
        } else {
            next();
        }
    },
    methods: {
        async initialSearchFromIndex () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            const beginDate = dayjs().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
            const endDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.completionTime = [beginDate, endDate];
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.confirmStatus = this.$route.query.confirmStatus || '';
            this.loading = true;
            this.searchParams = {
                pageNo: 1,
                pageSize: this.searchParams.pageSize,
                param: {
                    dispatchCompletionTimeStart: beginDate,
                    dispatchCompletionTimeEnd: endDate,
                    confirmStatus: this.$route.query.confirmStatus || '',
                    carrierCode: this.supplier.supplierCode
                }
            };
            await this.getDicData();
            await Promise.all([ this.getList()])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'OTP_APPLY_STATUS,PUSH_BMS_FLAG,PUSH_TYPE'
            );
            this.dictData = dict.data;
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            // 执行操作
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
            this.queryApolloSiteCodeList();
            this.isFirstSearch = false;
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        getList () {
            this.loading = true;
            this.searchParams.param = removeFalsyValues(this.searchParams.param);
            this.queryCount();
            queryPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCode: this.supplier.supplierCode // 供应商编码-LSP
                }
            };
            return _searchData;
        },
        queryCount () {
            queryCount(this.searchParams.param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        queryApolloSiteCodeList () {
            queryApolloSiteCodeList().then(res => {
                if (res && +res.code === 0) {
                    this.siteCodeList = res.data || [];
                }
            }).catch(() => { });
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams.param,
                siteCodeList: this.siteCodeList,
                tenantCode: this.currentTenant.tenantCode,
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00'
            });
            this.isFirstSearch = false;
        },
        /*
         * @description 行内按钮触发
         * @param {String} val 当前按钮文本
         * @param {Number} index 当前行索引
         * @param {Object} row 当前行数据
         */
        handleBtnClick (val, index, row, prop) {
            if (prop === 'photos' && val === '查看') {
                this.queryDriverAttachment(row);
            } else if (prop === 'iflowStatusName' && row.requestId) {
                this.$router.push({
                    path: '/otp/transport-center/driver-expense-manage-mip',
                    query: {
                        requestId: row.requestId
                    }
                });
            } else if (prop === 'pushBmsFlagName') {
                this.rowData = row;
                this.confirmStatusDialogShow = true;
            }
        },
        /**
         * @description  司机确认凭证 附件查询
         */
        queryDriverAttachment (rowData) {
            if (+rowData.driverCertificate === 1 && rowData.id) {
                const params = {
                    objId: rowData.id,
                    objType: 'DRIVER_COST_CONFIRM'
                };
                queryDriverAttachment(params).then(res => {
                    if (res && +res.code === 0) {
                        this.attachmentList = res.data || [];
                        if (this.attachmentList.length) {
                            this.attachmentShow = true;
                        }
                    }
                }).catch(() => { });
            }
        },
        // 批量操作 异常申诉
        handleApproval () {
            const companyList = this.selected.map(v => v.companyName);
            if (new Set(companyList).size !== 1) {
                return this.$message.warning('选中的发车单包含多个分公司！仅同个分公司的发车单支持批量发起异常申诉，请重新选择。');
            }
            const disableData = this.selected.filter(v => v.confirmStatus !== '0');
            if (disableData.length) {
                return this.$message.warning('仅司机费用确认状态为“待确认”的发车单支持发起异常申诉，请重新选择发车单，再发起申诉。');
            }
            // 已发起审批(审批状态为草稿、审核中、审核通过、驳回)，不允许再次发起
            const approvalData = this.selected.filter(v => ['D', 'R', 'P', 'J'].includes(v.iflowStatus));
            if (approvalData.length) {
                return this.$message.warning('选中的数据中包括已发起审批的发车单，请刷新页面后重新选择。');
            }
            // 账单付款日期为空 或 当前日期＜账单付款日期，不可发起异常申诉
            const disabledBillPaymentTimeData = this.selected.filter(v => !v.billPaymentDate || dayjs().startOf('day').isBefore(dayjs(v.billPaymentDate).startOf('day')));
            if (disabledBillPaymentTimeData.length) {
                const dispatchNos = disabledBillPaymentTimeData.map(v => v.dispatchNo).join('、');
                return this.$message.warning(`以下发车单未到账单付款日期，不可发起异常申诉: ${dispatchNos}`);
            }
            const dispatchNoList = this.selected.map(v => v.dispatchNo);
            this.approvalBtnLoading = true;
            abnormalAppeal({ dispatchNoList, sourceType: '30'})
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            this.$router.push({
                                path: '/otp/transport-center/driver-expense-manage-mip',
                                query: {
                                    requestId: res.data
                                }
                            });
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.approvalBtnLoading = false;
                });
        },
        // 刷新页面
        refresh (dialogVisible) {
            this[dialogVisible] = false;
            this.getList();
        },
        // 选中表格行
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
